module.exports = __webpack_public_path__ + "img/arrow-dark.b873da70.svg";